import React, { useState } from 'react';
import logo from '../assets/images/logo.png';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
      
      // Reset status after 3 seconds
      setTimeout(() => setSubmitStatus(null), 3000);
    }, 1500);
  };

  return (
    <div className="contact-page">
      <section className="hero-section">
        <div className="home-container">
          <div className="home-content">
            <div className="logo-section">
              <div className="logo">
                <img src={logo} alt="Image Technology Logo" className="logo-image" />
              </div>
            </div>
            <div className="text-section">
              <h2>Contact Us</h2>
              <p>
                Have a question or need expert support? Our team is here to assist you with all your printing and imaging needs—from product inquiries to partnership opportunities. Let's connect and create something impactful together.
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="contact-content">
        <div className="contact-grid">
          <div className="contact-info">
            <h2>Get In Touch</h2>
            <p>
              We'd love to hear from you. Send us a message and we'll respond 
              as soon as possible.
            </p>
            
            <div className="contact-details">
              <div className="contact-item">
                <div className="contact-icon">📍</div>
                <div>
                  <h4>Address</h4>
                  <p>Shop No. 30, DISCOVERY COMPLEX,<br />Dattapada Rd, Dattapada, Borivali East, Mumbai, Maharashtra 400066</p>
                </div>
              </div>
              
              <div className="contact-item">
                <div className="contact-icon">📧</div>
                <div>
                  <h4>Email</h4>
                  <p>
                    General Enquiry Mail Us: info@imagetechnology.in<br />
                    For Sales Service: sales.mumbai@imagetechnology.in<br />
                    For Technical Support: support@imagetechnology.in<br />
                    For Accounts Department: accounts@imagetechnology.in
                  </p>
                </div>
              </div>
              
              <div className="contact-item">
                <div className="contact-icon">📞</div>
                <div>
                  <h4>Phone</h4>
                  <p>+91 7710051373</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">💳</div>
                <div>
                  <h4>GST NO</h4>
                  <p>27AAJPP2191C1ZR</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">✅</div>
                <div>
                  <h4>ISO Certified</h4>
                  <p>9001:2015</p>
                </div>
              </div>
              
              <div className="contact-item">
                <div className="contact-icon">🕒</div>
                <div>
                  <h4>Business Hours</h4>
                  <p>Monday - Friday: 9AM - 6PM<br />Saturday: 10AM - 4PM</p>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-form-container">
            <form className="contact-form" onSubmit={handleSubmit}>
              <h3>Send us a Message</h3>
              
              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Enter your full name"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="Enter your email address"
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder="What is this about?"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="6"
                  placeholder="Tell us more about your inquiry..."
                ></textarea>
              </div>

              <button 
                type="submit" 
                className="submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>

              {submitStatus === 'success' && (
                <div className="success-message">
                  Thank you! Your message has been sent successfully.
                </div>
              )}
            </form>
          </div>
        </div>

        <div className="map-section">
          <h2>Find Us</h2>
          <div className="map-placeholder" style={{padding: 0, height: '400px'}}>
            <iframe
              title="Office Location"
              src="https://www.google.com/maps?q=Image+Technology,+Shop+No.+30,+DISCOVERY+COMPLEX,+Dattapada+Rd,+Dattapada,+Borivali+East,+Mumbai,+Maharashtra+400066&output=embed"
              width="100%"
              height="400"
              style={{ border: 0, borderRadius: '15px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact; 